module.exports = "pegasus_template/assets/theme6/medium/4.jpg";